var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { C } from '#integrations';
import { generateHSL, hashString } from '#services';
import { Typography } from '../Typography';
import { LabelTestIdFactory } from './interactions';
import { LABEL_COLORS_COUNT } from './Label.constants';
import styles from './Label.module.css';
const COLOR_CLASS_MAP = {
    static_0: styles.Static0,
    static_1: styles.Static1,
    static_2: styles.Static2,
    static_3: styles.Static3,
    static_4: styles.Static4,
    static_5: styles.Static5,
    static_6: styles.Static6,
    static_info: styles.StaticInfo,
    static_error: styles.StaticError,
    static_alert: styles.StaticAlert,
    static_success: styles.StaticSuccess,
};
const sizeToTypographyKindMap = {
    big: 'generic',
    medium: 'generic-small',
    small: 'generic-tiny',
};
const SIZE_CLASS_MAP = {
    big: styles.ContainerBig,
    medium: styles.ContainerMedium,
    small: styles.ContainerSmall,
};
const sizeToIconSizeMap = {
    big: 'small',
    medium: 'xsmall',
    small: 'xxsmall',
};
const TEXT_SIZE_CLASS_MAP = {
    big: undefined,
    medium: styles.LabelMedium,
    small: undefined,
};
export const Label = ({ className, color = 'static_1', 'data-test-state': testState, 'data-testid': testId, hasTitle, isTruncatable, ref, size = 'medium', StartIcon = undefined, text, }) => {
    _react_refresh_temp_2();
    const [colorClassName, style] = useMemo(() => {
        if (typeof color === 'object') {
            return [
                styles.Dynamic,
                {
                    color: generateHSL({
                        value: hashString(color.generateFrom),
                        colors: LABEL_COLORS_COUNT,
                    }),
                },
            ];
        }
        return [COLOR_CLASS_MAP[color], {}];
    }, [color]);
    return (_jsxs("span", { className: C(SIZE_CLASS_MAP[size], colorClassName, className, isTruncatable && styles.Truncatable), "data-testid": LabelTestIdFactory.getLabelTestId(testId), ref: ref, style: style, ...(testState && { 'data-test-state': testState }), ...(hasTitle && { title: text }), children: [StartIcon ? _jsx(StartIcon, { size: sizeToIconSizeMap[size] }) : null, _jsx(Typography, { className: C(TEXT_SIZE_CLASS_MAP[size]), color: "inherit", "data-testid": LabelTestIdFactory.getLabelTextTestId(testId), kind: sizeToTypographyKindMap[size], children: text })] }));
};
_react_refresh_temp_1 = Label;
$RefreshReg$(_react_refresh_temp_1, "Label");
_react_refresh_temp_2(Label, "HTIF85M6JVqepbvTTwp8ObzVAEs=");
